<template>
  <div class="pricing-promo-card" :class="[{ deletion: isMarkedForDeletion }]">
    <md-button class="md-icon-button md-danger" @click="toggleDelete">
      <md-icon>close</md-icon>
    </md-button>

    <div class="md-layout">
      <md-datepicker v-model="promoInfo.date_min" md-immediately class="md-size-50 md-small-size-100">
        <label>Promo Period Starts</label>
      </md-datepicker>
      <md-datepicker v-model="promoInfo.date_max" md-immediately class="md-size-50 md-small-size-100">
        <label>Promo Period Ends</label>
      </md-datepicker>
    </div>

    <div class="md-layout">
      <md-field>
        <label>Name</label>
        <md-select v-model="promoInfo.name" required>
          <md-option value="standard_trial">standard_trial</md-option>
          <md-option value="launch_promo">launch_promo</md-option>
        </md-select>
      </md-field>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-size-5" />
      <md-field class="md-layout-item md-size-60">
        <label>Service %</label>
        <md-input v-model.number="promoInfo.percent" type="number" min="0" step="0.01" />
        <strong>%</strong>
      </md-field>
    </div>
  </div>
</template>

<script>
export default {
  name: "pricing-promo-card",
  props: {
    promoInfo: {
      type: Object,
      default: {
        name: "standard_trial",
        date_min: null,
        date_max: null,
        percent: 3.0,
        _destroy: null
      }
    },
  },
  computed: {
    isMarkedForDeletion() {
      return this.promoInfo["_destroy"]
    }
  },
  methods: {
    toggleDelete() {
      this.$emit("toggleDelete", this.promoInfo)
    }
  }
}
</script>

<style lang=scss>
  #toSpan {
    line-height: 60px;
    height: 60px;
  }
  .inline-field {
    display: inline-flex;
  }
  .pricing-promo-card {
    padding: 10px;
    margin: 0px 10px;
    display: inline-block;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
    -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
    border-radius: 6px;
    width: 250px;
  }
  .md-input {
    width: 100%;
  }
  .deletion {
    opacity: .9;
    background-color: #fdd;
  }
</style>
